import React from "react";
import { Footprints, BookOpen, Mic, Compass, Library, Flame, Map, Award, Medal, Trophy } from "lucide-react";

// Distinct MELLETIC achievement symbols (not the same trophy for everything).
const ICONS = {
  first_step: Footprints,
  first_words: BookOpen,
  speak_up: Mic,
  real_life: Compass,
  words_25: BookOpen,
  words_100: Library,
  words_250: Library,
  words_500: Medal,
  words_1000: Trophy,
  streak_7: Flame,
  streak_30: Flame,
  a1_explorer: Map,
  a1_complete: Award,
  a2_complete: Award,
  b1_complete: Award,
  b2_complete: Award,
  c1_complete: Award,
  mastery: Trophy,
};

export default function AchievementIcon({ code, size = 20, className = "" }) {
  const Icon = ICONS[code] || Medal;
  return <Icon size={size} className={className} />;
}
